// extracted by mini-css-extract-plugin
export var chevronIcon = "_cc-2";
export var teamName = "_cc-1";
export var teamSwitcherButton = "_cc-0";